import { InlineEditor } from "./InlineEditor";
import type { EditorProps } from "./editorProps";

/**
 * Opens with the day as `Sep 20, 2026`; also accepts `Sep 20`, `9/20`,
 * `9/20/2026`, and `2026-09-20`. Commits a `YYYY-MM-DD` day. A day without
 * a year lands in the year of the workspace `today` (`editing.today`), so
 * `Dec 31` typed on Jan 2 is eleven months out, not two days back; without
 * `today`, it doesn't parse.
 */
export const DateEditor = (props: EditorProps) => (
    <InlineEditor {...props} align="start" placeholder="MMM D, YYYY" />
);
